









































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { CreateActivityCategoryRequest, ActivityCategoryDto } from '@/models/Activities';

@Component({
    name: 'ActivityCategoryCreate'
})
export default class extends GiganautVueDialog {

  public entity = new ActivityCategoryDto();

  colorOptions = [
    { text: 'Blue', value: '#2196F3' },
    { text: 'Green', value: '#4CAF50' },
    { text: 'Orange', value: '#FF9800' },
    { text: 'Red', value: '#F44336' },
    { text: 'Purple', value: '#9C27B0' },
    { text: 'Teal', value: '#009688' },
    { text: 'Pink', value: '#E91E63' },
    { text: 'Indigo', value: '#3F51B5' },
    { text: 'Grey', value: '#9E9E9E' }
  ];

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new ActivityCategoryDto();
      this.entity.color = '#2196F3';
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new CreateActivityCategoryRequest();
    request.name = this.entity.name;
    request.description = this.entity.description;
    request.color = this.entity.color;
    request.sortOrder = this.entity.sortOrder;
    // Worker
    request.isEnabledOnWorkerTask = this.entity.isEnabledOnWorkerTask;
    request.isEnabledOnWorkerNote = this.entity.isEnabledOnWorkerNote;
    request.isEnabledOnWorkerCall = this.entity.isEnabledOnWorkerCall;
    request.isEnabledOnWorkerMeeting = this.entity.isEnabledOnWorkerMeeting;
    request.isEnabledOnWorkerEmail = this.entity.isEnabledOnWorkerEmail;
    // Company
    request.isEnabledOnCompanyTask = this.entity.isEnabledOnCompanyTask;
    request.isEnabledOnCompanyNote = this.entity.isEnabledOnCompanyNote;
    request.isEnabledOnCompanyCall = this.entity.isEnabledOnCompanyCall;
    request.isEnabledOnCompanyMeeting = this.entity.isEnabledOnCompanyMeeting;
    request.isEnabledOnCompanyEmail = this.entity.isEnabledOnCompanyEmail;
    // Location
    request.isEnabledOnLocationTask = this.entity.isEnabledOnLocationTask;
    request.isEnabledOnLocationNote = this.entity.isEnabledOnLocationNote;
    request.isEnabledOnLocationCall = this.entity.isEnabledOnLocationCall;
    request.isEnabledOnLocationMeeting = this.entity.isEnabledOnLocationMeeting;
    request.isEnabledOnLocationEmail = this.entity.isEnabledOnLocationEmail;
    // Contact
    request.isEnabledOnContactTask = this.entity.isEnabledOnContactTask;
    request.isEnabledOnContactNote = this.entity.isEnabledOnContactNote;
    request.isEnabledOnContactCall = this.entity.isEnabledOnContactCall;
    request.isEnabledOnContactMeeting = this.entity.isEnabledOnContactMeeting;
    request.isEnabledOnContactEmail = this.entity.isEnabledOnContactEmail;
    // Job
    request.isEnabledOnJobTask = this.entity.isEnabledOnJobTask;
    request.isEnabledOnJobNote = this.entity.isEnabledOnJobNote;
    request.isEnabledOnJobCall = this.entity.isEnabledOnJobCall;
    request.isEnabledOnJobMeeting = this.entity.isEnabledOnJobMeeting;
    request.isEnabledOnJobEmail = this.entity.isEnabledOnJobEmail;
    // Booking
    request.isEnabledOnBookingTask = this.entity.isEnabledOnBookingTask;
    request.isEnabledOnBookingNote = this.entity.isEnabledOnBookingNote;
    request.isEnabledOnBookingCall = this.entity.isEnabledOnBookingCall;
    request.isEnabledOnBookingMeeting = this.entity.isEnabledOnBookingMeeting;
    request.isEnabledOnBookingEmail = this.entity.isEnabledOnBookingEmail;
    // Campaign
    request.isEnabledOnCampaignTask = this.entity.isEnabledOnCampaignTask;
    request.isEnabledOnCampaignNote = this.entity.isEnabledOnCampaignNote;
    request.isEnabledOnCampaignCall = this.entity.isEnabledOnCampaignCall;
    request.isEnabledOnCampaignMeeting = this.entity.isEnabledOnCampaignMeeting;
    request.isEnabledOnCampaignEmail = this.entity.isEnabledOnCampaignEmail;
    // Opportunity
    request.isEnabledOnOpportunityTask = this.entity.isEnabledOnOpportunityTask;
    request.isEnabledOnOpportunityNote = this.entity.isEnabledOnOpportunityNote;
    request.isEnabledOnOpportunityCall = this.entity.isEnabledOnOpportunityCall;
    request.isEnabledOnOpportunityMeeting = this.entity.isEnabledOnOpportunityMeeting;
    request.isEnabledOnOpportunityEmail = this.entity.isEnabledOnOpportunityEmail;

    await AgencySettingsModule.createActivityCategory(request);
    this.dialog = false;
  }
}
